import React from 'react';
import {Container, Stack, Typography} from '@mui/material';

const LegalContentWrapper = props=>{
    let {lastUpdated, title, children} = props;
    return <Container maxWidth="lg">
      <Stack direction="column" gap={4} marginBottom={6}>
        <Stack direction="row" gap={2} justifyContent="space-between" alignItems="center" flexWrap="wrap">
          <Typography variant="h3">{title}</Typography>
          <Typography fontStyle="italic">עודכן ביום {lastUpdated}</Typography>
        </Stack>
        <Stack direction="column" gap={4}>
          {children}
        </Stack>
      </Stack>
    </Container>;
};

export default LegalContentWrapper;
